import styled, { css } from 'styled-components';

import {
    Text,
    mediaMixin,
    token,
    spaceMixin,
} from '@zillow/constellation';

export const StyledDetailsComponent = styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    justify-content: space-around;
    align-items: center;
    text-align: center;

    margin-bottom: ${spaceMixin('sm')};

    /* 769 */
    ${mediaMixin('lg', css`
        flex-direction: column;
        margin-bottom: 0;
    `)}

    /* 1025 */
    ${mediaMixin('xl', css`
        flex-direction: row;
        margin-bottom: ${spaceMixin('sm')};
    `)}
`;

export const StyledItemContainer = styled.div`
    margin-bottom: 0;

    /* 769 */
    ${mediaMixin('lg', css`
        margin-bottom: 27px;

        /* weekly fee */
        &:nth-of-type(3) {
            display: none;
        }
    `)}

    /* 1025 */
    ${mediaMixin('xl', css`
        margin-bottom: 0;
    `)}
`;

export const StyledHeader = styled(Text)`
    margin-bottom: 4px;
    color: ${token('colors.gray600')};
    white-space: nowrap;
`;

export const StyledData = styled(Text)`
    font-weight: bold;
    color: ${token('colors.gray600')};
    white-space: nowrap;
`;

export const StyledWeeklyFee = styled(Text)`
    display: none;
    /* per constellation docs finePrint is 12px, but not reflecting in ui */
    font-size: 12px;

    /* 769 */
    ${mediaMixin('lg', css`
        display: block;
    `)}

    /* 1025 */
    ${mediaMixin('xl', css`
        display: none;
    `)}
`;

export const StyledTooltipText = styled(Text)`
    display: block;
    padding: 4px;
`;
